// ./src/contexts/PersonGroupsContext/PersonGroupsContext.tsx
//
// Thin context wrapper around the usePersonGroups hook — shared by the contact
// editor's group picker (list + create-in-place).

import React, { createContext, useContext } from "react";

import {
  usePersonGroups,
  UsePersonGroupsOptions,
  UsePersonGroupsReturn,
} from "@/hooks/usePersonGroups";

const PersonGroupsContext = createContext<UsePersonGroupsReturn | null>(null);

export interface PersonGroupsProviderProps extends UsePersonGroupsOptions {
  children: React.ReactNode;
}

export const PersonGroupsProvider: React.FC<PersonGroupsProviderProps> = ({ children, ...options }) => {
  const value = usePersonGroups(options);

  return <PersonGroupsContext.Provider value={value}>{children}</PersonGroupsContext.Provider>;
};

export const usePersonGroupsContext = (): UsePersonGroupsReturn => {
  const context = useContext(PersonGroupsContext);

  if (!context) {
    throw new Error(
      "usePersonGroupsContext must be used within a <PersonGroupsProvider>. " +
        "Wrap your component tree with <PersonGroupsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPersonGroupsContext = (): UsePersonGroupsReturn | null => {
  return useContext(PersonGroupsContext);
};
